import { render, staticRenderFns } from "./deleteAccountStatementModal.vue?vue&type=template&id=2e0926f5&"
import script from "./deleteAccountStatementModal.vue?vue&type=script&lang=js&"
export * from "./deleteAccountStatementModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports